import type { GreetingsScope } from '../Greetings';
import { AfternoonIcon, EveningIcon, MorningIcon } from './icons';

const GreetingsIcon = ({ className, scope }: { className?: string; scope: GreetingsScope }) => {
  switch (scope) {
    case 'afternoon':
      return <AfternoonIcon className={className} />;
    case 'evening':
      return <EveningIcon className={className} />;
    case 'morning':
      return <MorningIcon className={className} />;
  }
};

export default GreetingsIcon;
